import React from "react";
import { FaChartLine, FaCogs, FaUsers, FaTasks } from "react-icons/fa";

const Achiv = () => {
  return (
    <div className="bg-[#114497] py-10">
      <div className="max-w-screen-lg mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10 text-[#fbb613]">
 
          {/* Revenue */}
          {/* <div className="flex flex-col items-center text-center relative">
            <FaChartLine className="text-4xl sm:text-5xl" />
            <p className="text-sm font-bold mt-2">REVENUE</p>
            <h2 className="text-3xl sm:text-4xl font-bold">1,500+</h2>
            <p className="text-base sm:text-lg font-medium">Crore</p>
            <span className="absolute text-6xl sm:text-8xl font-bold opacity-10 top-1/2 transform -translate-y-1/2 pointer-events-none">
              1500+
            </span>
          </div>

          {/* Machineries */}
          {/* <div className="flex flex-col items-center text-center relative">
            <FaCogs className="text-4xl sm:text-5xl" />
            <p className="text-sm font-bold mt-2">Machineries</p>
            <h2 className="text-3xl sm:text-4xl font-bold">2,500+</h2>
            <span className="absolute text-6xl sm:text-8xl font-bold opacity-10 top-1/2 transform -translate-y-1/2 pointer-events-none">
              2500+
            </span>
          </div>*/}
           <div className="flex flex-col items-center text-center relative">
            <FaUsers className="text-4xl sm:text-5xl" />
            <p className="text-sm font-bold mt-2">Happy Customers</p>
            <h2 className="text-3xl sm:text-4xl z-10 font-bold">14,000+</h2>
            <span className="absolute text-6xl sm:text-8xl font-bold text-blue-950  opacity-20 top-1/2 transform -translate-y-1/2 pointer-events-none">
              14000+
            </span>
          </div>
          {/* Completed Projects */}
          <div className="flex flex-col items-center text-center relative">
            <FaTasks className="text-4xl sm:text-5xl" />
            <p className="text-sm font-bold mt-2">Completed Projects</p>
            <h2 className="text-3xl sm:text-4xl z-20 font-bold">100+</h2>
            <span className="absolute text-6xl sm:text-8xl font-bold text-blue-950  opacity-20  top-1/2 transform -translate-y-1/2 pointer-events-none">
              100+
            </span>
          </div>
 <div className="flex flex-col items-center text-center relative">
<span>
  
</span>
 </div>
 
 </div>
      </div>
    </div>
  );
};

export default Achiv;
